import { APIGEOLOCATION_STREETTOCOORD } from "../evironment";
import { isLoggedIn } from './session';
const apiKey = APIGEOLOCATION_STREETTOCOORD;
const url = 'https://eu1.locationiq.com/v1/search.php';
export class GeolocationStreetService {
    constructor(uiService, paramsService) {
        this.uiService = uiService;
        this.paramsService = paramsService;
    }
    async streetToCoords(direction) {
        if (direction.id) {
            const streetTypeName = direction.streetTypeId ? await this.getName(direction.streetTypeId) : '';
            const streetName = direction.streetId ? await this.getName(direction.streetId) : '';
            const districName = direction.districId ? await this.getName(direction.districId) : '';
            const municipalityName = direction.municipalityId ? await this.getName(direction.municipalityId) : '';
            const provinceName = direction.provinceId ? await this.getName(direction.provinceId) : '';
            const countryName = direction.countryId ? await this.getName(direction.countryId) : '';
            const params = new URLSearchParams({
                key: apiKey,
                q: (streetTypeName + ',' +
                    streetName + ',' +
                    districName + ',' +
                    municipalityName + ',' +
                    provinceName + ',' +
                    countryName),
                format: 'json'
            });
            const response = await this.get(params);
            if (!response.ok) {
                throw new Error(`Error al obtener las coordenadas.`);
            }
            const content = await response.json();
            if (content) {
                const moreExacty = content[0];
                return { lon: parseFloat(moreExacty.lon), lat: parseFloat(moreExacty.lat) };
            }
            return null;
        }
        else {
            throw new Error(`Error al obtener las dirección.`);
        }
    }
    async getName(id) {
        return await this.paramsService.findOne(id).then(param => param.name);
    }
    async get(params) {
        try {
            const headers = {};
            if (!isLoggedIn()) {
                throw new Error("El usuario no esta logueado");
            }
            return await fetch(`${url}?${params}`, {
                method: 'GET',
                headers,
            });
        }
        catch (err) {
            console.error(err);
            this.uiService.notifyError('Ha ocurrido un error de red.');
        }
    }
}
